import { faqItems } from './faq-items-en.i18n';

export const en = {
  faqItems,
};
